import { Container, Row, Col } from "react-bootstrap";
import { RowsPhotoAlbum } from "react-photo-album";
import { useEffect, useState, useRef } from "react";

export const Gallery = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [visibleYear, setVisibleYear] = useState(null);
    const yearRefs = useRef({});

    // Cloudinary base URL with your cloud name
    const CLOUDINARY_URL = "https://res.cloudinary.com/df7wtdlud/image/upload";

    const photosByYear = {
        2022: [
            {
                src: `${CLOUDINARY_URL}/f_auto,q_auto/v1768258126/INUMAKI_w9ko3o.png`,
                width: 2850,
                height: 2000,
                title: "Inumaki - JJK",
                year: 2022
            },
            {
                src: `${CLOUDINARY_URL}/f_auto,q_auto/v1768257722/lumity_mwk7iy.png`,
                width: 2850,
                height: 2100,
                title: "Lumity - TOH",
                year: 2022
            },
            {
                src: `${CLOUDINARY_URL}/f_auto,q_auto/v1768257715/praiseteam_k7fqcm.png`,
                width: 2150,
                height: 2200,
                title: "Group Photo",
                year: 2022
            },
            {
                src: `${CLOUDINARY_URL}/f_auto,q_auto/v1768257715/silentvoice_p72sku.png`,
                width: 2100,
                height: 1975,
                title: "Yuzuru Nishimiya - A Silent Voice",
                year: 2022
            },
            {
                src: `${CLOUDINARY_URL}/f_auto,q_auto/v1768258243/sketch_tdpddn.png`,
                width: 2300,
                height: 2000,
                title: "Sketch",
                year: 2022
            },
        ],
        2021: [
            {
                src: `${CLOUDINARY_URL}/f_auto,q_auto/v1768257675/kiyoko_zvfjmi.png`,
                width: 1867,
                height: 1867,
                title: "Mello DTIYS - Kiyoko HQ",
                year: 2021
            },
            {
                src: `${CLOUDINARY_URL}/f_auto,q_auto/v1768257669/lemon_kikvus.png`,
                width: 1155,
                height: 1175,
                title: "Lemon Sketch",
                year: 2021
            },
            {
                src: `${CLOUDINARY_URL}/f_auto,q_auto/v1768257677/mulan_fp1zwj.png`,
                width: 2150,
                height: 1700,
                title: "Mulan",
                year: 2021
            },
            {
                src: `${CLOUDINARY_URL}/f_auto,q_auto/v1768257674/rindewdtiys_qv28uu.png`,
                width: 1400,
                height: 1450,
                title: "Rindew DTIYS",
                year: 2021
            },
            {
                src: `${CLOUDINARY_URL}/f_auto,q_auto/v1768257679/sailormoon_bgwdxc.png`,
                width: 1740,
                height: 1500,
                title: "Sailor Moon Redraw",
                year: 2021
            },
            {
                src: `${CLOUDINARY_URL}/f_auto,q_auto/v1768257672/saeko_i980aq.png`,
                width: 1300,
                height: 1200,
                title: "Saeko Tanaka - Haikyuu",
                year: 2021
            },
            {
                src: `${CLOUDINARY_URL}/f_auto,q_auto/v1768257675/yuna_puwy1b.png`,
                width: 1400,
                height: 1450,
                title: "Yuna - Odd Girl Out",
                year: 2021
            },
        ],
    };

    // Get years in descending order 
    const years = Object.keys(photosByYear).sort((a, b) => b - a);

    useEffect(() => {
        const observerOptions = {
            root: null,
            rootMargin: '-100px 0px -60% 0px',
            threshold: 0
        };

        const observerCallback = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const year = entry.target.dataset.year;
                    setVisibleYear(year);
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);

        // Observe all year sections 
        Object.keys(yearRefs.current).forEach((year) => {
            if (yearRefs.current[year]) {
                observer.observe(yearRefs.current[year]);
            }
        });

        return () => observer.disconnect();
    }, []);

    return ( 
        <section className="gallery" id="gallery">
            <Container>
                <Row>
                    <Col size={12}>
                        <div className="gallery-bx">
                            <h2>Art Gallery</h2>
                            <p>Collection of previous drawings, showcasing progress over the years</p>
                            
                            {/* Year Indicator */}
                            <div className={`floating-year ${visibleYear ? 'visible' : ''}`}>
                                {visibleYear}
                            </div>

                            {/* Photo album organized by year */}
                            {years.map((year) => (
                                <div 
                                    key={year}
                                    className="year-section"
                                    ref={(el) => yearRefs.current[year] = el}
                                    data-year={year}
                                >
                                    <div className="year-header">
                                        <h3>{year}</h3>
                                        <div className="year-divider"></div>
                                    </div>

                                    <RowsPhotoAlbum
                                        photos={photosByYear[year]}
                                        targetRowHeight={400}
                                        spacing={12}
                                        padding={0}
                                        onClick={({ photo }) => setSelectedImage(photo)}
                                        componentsProps={{
                                            imageProps: { loading: "lazy"}
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>

            {/* Lightbox Modal */}
            {selectedImage && (
                <div className="lightbox" onClick={() => setSelectedImage(null)}>
                    <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                        <button className="lightbox-close" onClick={() => setSelectedImage(null)}>×</button>
                        <img src={selectedImage.src} alt={selectedImage.title} />
                    </div>
                </div>
            )}
        </section>
    );
};